import { ValidationSchema } from 'forms';
import { OfficeLocationFormData } from './types';
import { PINCODE_REGEX } from 'utils/regexes';
import { FormInstance } from './store/types';
import { CreateOfficeLocationRequest } from 'api/types/officeLocationTypes';

export const validationSchema: ValidationSchema<OfficeLocationFormData> = {
  officeName: (formData) => (formData.officeName?.trim() ? null : 'Office Name is required'),
  officeAddress: (formData) =>
    formData.officeAddress?.trim() ? null : 'Office Address is required',
  state: (formData) => (formData.state?.length ? null : 'State is required'),
  district: (formData) => (formData.district?.length ? null : 'District is required'),
  pincode: (formData) => {
    if (!formData.pincode?.length) {
      return 'Pincode is required';
    }
    if (!PINCODE_REGEX.test(formData.pincode)) {
      return 'Pincode is invalid';
    }
    return null;
  },
  esicSubCode: (formData) => {
    if (formData.esicSubCode && !/^\d+$/.test(formData.esicSubCode)) {
      return 'Enter a valid number';
    }
    return null;
  },
};

export const defaultFormData: OfficeLocationFormData = {
  id: 'new-form-1',
  officeName: '',
  officeAddress: '',
  state: [],
  district: [],
  pincode: '',
  esicDispensary: [],
  esicSubCode: '',
};

export const getCreateOfficeLocationsPayload = (
  forms: Record<string | number, FormInstance>,
): CreateOfficeLocationRequest => {
  return {
    office_locations: Object.values(forms).map((form) => {
      return {
        office_name: form.formData.officeName ?? '',
        address_line_1: form.formData.officeAddress ?? '',
        address_line_2: '',
        district: form.formData.district?.[0] ?? '',
        state: Number(form.formData.state?.[0]),
        pincode: form.formData.pincode ?? '',
        esic_dispensary: form.formData.esicDispensary?.[0] ?? null,
        esic_sub_code: form.formData.esicSubCode ? Number(form.formData.esicSubCode) : null,
        is_primary: false,
      };
    }),
  };
};
